module.exports = __webpack_public_path__ + "static/img/banner-品倍福@2x.1d82929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner-品倍福@2x.png
// module id = R6gT
// module chunks = 1